// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"506e204f","491":"8c887796","500":"a2deb4c9","577":"a02cc9f9","647":"d6865e90","904":"a0326487","991":"5315ef39"}[chunkId] + ".chunk.js";
};